<template>
  <Gallery v-if="loaded" :title="store.item.title" :variant="store.selected.variant" :shortDescription="shortDescription" :gallery="store.gallery" :option="store.selected.gallery" :id="store.item.id.split('/Product/')[1]" />
  <Form v-if="loaded" location="pdp" />
  <ShopTheLookNavigation v-if="shopTheLookEnabled" :terms="terms" />
</template>

<script setup>
import * as Sentry from '@sentry/vue';
import { computed, onMounted, ref } from 'vue';
import { useProductStore } from './Composables/Store';

import Gallery from './Gallery.vue';
import Form from './Form.vue';
import ShopTheLookNavigation from './ShopTheLookNavigation.vue';

const props = defineProps({
  terms: Object,
  handle: String,
  variant: [String, Number],
  settings: Object,
  secondaryProducts: Array,
  secondaryProductsLabels: Array,
  secondaryProductsLimits: Array,
});

const shortDescription = computed(() => {
  return store?.item?.shortDescription?.value ?? '';
});

const loaded = ref(false);
const handle = props?.handle?.substring(1);
const store = useProductStore();
store.mountPromoListener();

const shopTheLookEnabled = computed(() => store.shopTheLookEnabled);

onMounted(async () => {
  Sentry.addIntegration(Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }));
  try {
    store.$state.terms = props.terms;
    store.$state.settings = props.settings;
    store.$state.gallery = await store.fetchGallery(handle);
    store.$state.item = await store.fetchProduct(handle);
    store.$state.upsell.items = [];
    if (store.$state.item?.upsell_products) {
      store.$state.upsell.items = store.$state.item?.upsell_products?.value.split('|') ?? [];
    }
    await store.setSecondaryProducts(props);
    await store.setInititalState(props);
    loaded.value = true;
  } catch (err) {
    Sentry.captureException(err);
    return err;
  }
});
</script>
